export default __webpack_public_path__ + "static/media/logo.1a36b953.png";